export const UPDATE_TEMP_STATE = 'UPDATE_TEMP_STATE';
export const RESET_TEMP_STATE = 'RESET_TEMP_STATE';
export const APP_READY_STATE = 'APP_READY_STATE';
export const HIDE_BACK_BUTTON_STATE = 'HIDE_BACK_BUTTON_STATE';
